import { formatDecimal } from "@/common/utils/formatters";

export const numberTickFormatter = (value: number): string => {
  if (value > 1000000) return formatDecimal(value / 1000000, 1, 0) + 'M';
  if (value > 1000) return formatDecimal(value / 1000, 1, 0) + 'k';
  return formatDecimal(value, 2, 0);
};
